import AddIcon from "@mui/icons-material/Add";
import { Button, FlexColumn } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { grey, white } from "designSystem/styles/color";
import BaseCompositionMaterialItem from "./BaseCompositionMaterialItem";
import { useBaseCompositionStore } from "./BaseCompositionStore";
import { BaseCompositionMaterial } from "./BaseCompositionMaterial";
import { CompositionPlacement } from "./CompositionPlacement";
import { MaterialOnBOM } from "./MaterialOnBOM";

export interface BaseCompositionMaterialListProps {

	/** void function to add a new baseCompositionMaterial */
	addBaseCompositionMaterial: VoidFunction;

	/** list of current baseCompositionMaterials used */
	baseCompositionMaterials: BaseCompositionMaterial[];

	/** If the compositionMaterials have an existing dummy, return true so they cannot add more. */
	compositionMaterialsHaveDummy: boolean;

	/** Parent placement to be used here */
	parent: CompositionPlacement | MaterialOnBOM;
}

const BaseCompositionMaterialList: FunctionComponent<BaseCompositionMaterialListProps> = observer(({
	parent,
	baseCompositionMaterials,
	addBaseCompositionMaterial,
	compositionMaterialsHaveDummy,
}) => {
	const {
		fromStyleBom,
		getDisableAddCompositionMaterial,
		disableCompositionMaterialEdit,
	} = useBaseCompositionStore();

	return (
		<FlexColumn
			alignItems="flex-start"
			gap={baseCompositionMaterials.length > 0 ? 2 : 0}
			paddingLeft={fromStyleBom ? 0 : 7}
			width="100%"
		>
			<FlexColumn
				bgcolor={fromStyleBom && baseCompositionMaterials.length === 0 ? white[50] : grey[50]}
				border={fromStyleBom && baseCompositionMaterials.length > 0 ? 1 : 0}
				borderColor={grey[300]}
				borderRadius={1}
				data-csi-automation="CompositionMaterial"
				gap={fromStyleBom && baseCompositionMaterials.length > 0 ? 0 : 2}
				width="100%"
			>
				{baseCompositionMaterials.map((baseCompositionMaterial, index) => (
					<BaseCompositionMaterialItem
						currentCompositionMaterial={baseCompositionMaterial}
						key={baseCompositionMaterial.key}
						parent={parent}
					/>
				))}
			</FlexColumn>
			<Button
				design="link"
				disabled={getDisableAddCompositionMaterial(parent, compositionMaterialsHaveDummy) || disableCompositionMaterialEdit}
				onClick={addBaseCompositionMaterial}
				res="CompositionMaterial"
				startIcon={<AddIcon />}
			/>
		</FlexColumn>
	);
});

export default BaseCompositionMaterialList;
